import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import pdf from '../../assets/images/file-pdf-solid.svg';
import csv from '../../assets/images/file-csv-solid.svg';
import { useAuth } from '../../hooks/customers/AuthProvider';
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import Select from "react-select";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { LoaderContext } from "../utils/Contexts";
//import 'rsuite/dist/rsuite.min.css';
import { DateRangePicker, Stack } from 'rsuite';

const columns = [
  { name: 'Branch', selector: row => row.branch, sortable: true },
  { name: 'PO No.', selector: row => row.poNo, sortable: true },
  { name: 'Delivery Date', selector: row => row.deliveryDate.display, sortable: true },
  { name: 'Invoice No.', selector: row => row.invoiceNo, sortable: true },
  { name: 'Total Spent', selector: row => `${row.totalSpent}`, sortable: true },
  {
    name: 'Payment Status',
    selector: row => row.status,
    cell: row => (
      <span style={{ fontWeight: '500', color: row.status === 'Paid' ? '#018c8f' : '#d70601' }}>
        {row.status}
      </span>
    ),
    sortable: true
  },
];

function Reportdatatable({ setInvoicesByMonth, setMonthlyPaidStatusCounts, setMonthlyPaidStatusAmounts }) {

  const pickerRef = useRef(null);
  const popupRef = useRef(null);
  const [active, setActive] = useState(false);

  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (pickerRef.current && pickerRef.current.contains(event.target)) {
  //       setActive(false);
  //     } else {
  //       setActive(true);
  //     }
  //   };

  //   const handleScroll = () => {
  //     setActive(true);
  //   };

  //   document.addEventListener('click', handleClick);
  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     document.removeEventListener('click', handleClick);
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);


  // useEffect(() => {
  //     const handleScroll = () => {
  //       document.body.classList.add('datepickdis');
  //     };

  //     const handleInputInteraction = (e) => {
  //       if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
  //         document.body.classList.remove('datepickdis');
  //       }
  //     };

  //     window.addEventListener('scroll', handleScroll);
  //     document.addEventListener('focus', handleInputInteraction, true);
  //     document.addEventListener('input', handleInputInteraction, true);
  //     document.addEventListener('click', handleInputInteraction, true);

  //     return () => {
  //       window.removeEventListener('scroll', handleScroll);
  //       document.removeEventListener('focus', handleInputInteraction, true);
  //       document.removeEventListener('input', handleInputInteraction, true);
  //       document.removeEventListener('click', handleInputInteraction, true);
  //     };
  //   }, []);


  const [currentPage, setCurrentPage] = useState(1);
  //const rowsPerPage = 10;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [inputKeyword, setInputKeyword] = useState('');
  const [filters, setFilters] = useState({
    keyword: '',
    branch: '',
    date: {
      start: null,
      end: null
    },
    paid: true,
    outstanding: true,
  });
  const auth = useAuth();
  const customerId = auth.customer.id;
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [invoice, setInvoice] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const { isLoader, setLoader } = useContext(LoaderContext);
  const [hasLoaded, setHasLoaded] = useState(false);
  //const [range, setRange] = useState([null, null]);
  const [range, setRange] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/rsuite@latest/dist/rsuite.min.css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // clean up
    };
  }, []);

  const getBranches = async () => {
    const url = `${ENDPOINTS.GET_BRANCHES}/${customerId}`;
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      const branchOptions = response?.data?.data.items.map(branch => ({
        value: branch.id,
        label: branch.company,
      }));
      const allOption = { value: '', label: 'All' };
      setBranches([allOption, ...branchOptions]);
    }
  }

  const getInvoiceDetails = async (company) => {
    setLoader(true);
    let url = `${ENDPOINTS.GET_INVOICE_DETAILS}/?&id=${customerId}`;
    if (company && company != 'All') {
      url += `&company=${encodeURIComponent(company)}`;
    }
    if (filters.keyword) {
      url += `&search=${encodeURIComponent(filters.keyword)}`;
    }
    const paidStatus = [];
    if (filters.paid) paidStatus.push('PAID');
    if (filters.outstanding) paidStatus.push('OUTSTANDING');

    if (paidStatus.length > 0) {
      for (const status of paidStatus) {
        url += `&paid_status=${status}`;
      }
    }

    if (filters.date) {
      url += `&date=${filters.date}`;
    }
    const response = await API.postWithToken(url);
    if (response.statusText === 'OK') {
      setInvoice(response?.data?.data.items.data);
      setHasLoaded(true);
      setLoader(false);
    }
  }
  useEffect(() => {
    getBranches();
  }, []);

  useEffect(() => {
    getInvoiceDetails(selectedBranch?.label);
  }, [selectedBranch, filters]);

  useEffect(() => {
    if (branches.length > 0 && !selectedBranch) {
      setSelectedBranch(branches[0]);
    }
  }, [branches]);


  const handleChanges = (e) => {
    const { id, value, type, checked } = e.target;
    if (id === 'inputKeyword') {
      setInputKeyword(value);
    } else {
      setFilters(prev => ({
        ...prev,
        [id]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFilters(prev => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const resetFilters = () => {
    setInputKeyword('');
    setFilters({
      keyword: '',
      branch: '',
      date: '',
      paid: true,
      outstanding: true,
    });
  };

  const handleSearch = () => {
    setFilters(prev => ({
      ...prev,
      keyword: inputKeyword,
    }));
  };
  const getDecimal = (val) => {
    if (!val) return 0;
    if (typeof val === 'object' && '$numberDecimal' in val) {
      return parseFloat(val.$numberDecimal);
    }
    return parseFloat(val);
  };

  const mapResponseToInitialData = (data) => {
    const now = new Date();
    const thisMonth = now.getMonth();
    const lastMonth = (thisMonth - 1 + 12) % 12;
    const twoMonthsAgo = (thisMonth - 2 + 12) % 12;
    const thisYear = now.getFullYear();

    const invoicesByMonth = {
      thisMonth: 0,
      lastMonth: 0,
      twoMonthsAgo: 0
    };

    const monthlyPaidStatusCounts = {
      thisMonth: { paid: 0, outstanding: 0 },
      lastMonth: { paid: 0, outstanding: 0 },
      twoMonthsAgo: { paid: 0, outstanding: 0 }
    };

    const monthlyPaidStatusAmounts = {
      thisMonth: { paid: 0, outstanding: 0 },
      lastMonth: { paid: 0, outstanding: 0 },
      twoMonthsAgo: { paid: 0, outstanding: 0 }
    };

    const tableData = data.map(item => {
      //const discountValue = getDecimal(item.discount_value);
      const taxPercent = parseFloat(item.total_tax);
      const shipping = getDecimal(item.shipping);
      const invTotal = getDecimal(item.inv_total);
      const spent = item.dollars_spent ? getDecimal(item.dollars_spent) : 0;

      const discountPercent = parseFloat(item.customer_discount || 0);
      let discountValue = (invTotal * discountPercent) / 100;
      discountValue = parseFloat(discountValue.toFixed(2));
      const baseTotal = parseFloat((invTotal + shipping - discountValue - spent).toFixed(2));
      const gst = parseFloat((baseTotal * taxPercent / 100).toFixed(2));
      const grandTotal = parseFloat((baseTotal + gst).toFixed(2));

      const delivery = new Date(item.delivery_date);
      const month = delivery.getMonth();
      const year = delivery.getFullYear();


      const mappedItem = {
        branch: item.customer_info?.company || '-',
        poNo: item.po_no && item.po_no.trim() !== '' ? item.po_no : '-',
        deliveryDate: {
          raw: item.delivery_date.split('T')[0],
          display: delivery.toLocaleDateString('en-GB')
        },
        invoiceNo: item.reference_no,
        totalSpent: `$${grandTotal.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`,
        status: item.paid_status === 'OUTSTANDING' ? 'Outstanding' : 'Paid'
      };

      // Grouping for pie chart
      const chartItem = {
        amount: parseFloat(grandTotal.toFixed(2)),
        invoiceNo: item.reference_no,
        customer: item.customer_info?.company || '-',
        date: delivery.toLocaleDateString('en-GB')
      };
      let monthKey = null;
      if (year === thisYear && month === thisMonth) {
        invoicesByMonth.thisMonth += grandTotal;
        monthKey = 'thisMonth';
      } else if (year === thisYear && month === lastMonth) {
        invoicesByMonth.lastMonth += grandTotal;
        monthKey = 'lastMonth';
      } else if (year === thisYear && month === twoMonthsAgo) {
        invoicesByMonth.twoMonthsAgo += grandTotal;
        monthKey = 'twoMonthsAgo';
      }

      if (monthKey) {
        if (item.paid_status === 'PAID') {
          monthlyPaidStatusCounts[monthKey].paid += 1;
          monthlyPaidStatusAmounts[monthKey].paid += grandTotal;
        } else if (item.paid_status === 'OUTSTANDING') {
          monthlyPaidStatusCounts[monthKey].outstanding += 1;
          monthlyPaidStatusAmounts[monthKey].outstanding += grandTotal;
        }
      }

      return mappedItem;
    });
    Object.keys(invoicesByMonth).forEach(key => {
      invoicesByMonth[key] = parseFloat(invoicesByMonth[key].toFixed(2));
    });
    setInvoicesByMonth(invoicesByMonth);

    Object.keys(monthlyPaidStatusAmounts).forEach(key => {
      monthlyPaidStatusAmounts[key].paid = parseFloat(monthlyPaidStatusAmounts[key].paid.toFixed(2));
      monthlyPaidStatusAmounts[key].outstanding = parseFloat(monthlyPaidStatusAmounts[key].outstanding.toFixed(2));
    });


    return {
      tableData,
      invoicesByMonth,
      monthlyPaidStatusCounts,
      monthlyPaidStatusAmounts
    };
  };

  //const { tableData: initialData, invoicesByMonth } = mapResponseToInitialData(invoice);
  const [initialData, setInitialData] = useState([]);
  useEffect(() => {
    if (!invoice || !Array.isArray(invoice)) return;

    const { tableData, invoicesByMonth, monthlyPaidStatusCounts, monthlyPaidStatusAmounts } =
      mapResponseToInitialData(invoice);

    setInitialData(tableData);
    setInvoicesByMonth(invoicesByMonth);
    setMonthlyPaidStatusCounts(monthlyPaidStatusCounts);
    setMonthlyPaidStatusAmounts(monthlyPaidStatusAmounts);
  }, [invoice]);

  const filteredData = useMemo(() => {
    const keyword = filters.keyword.toLowerCase();

    return initialData.filter((row) => {
      const matchKeyword =
        filters.keyword === '' ||
        Object.entries(row).some(([key, val]) => {
          if (typeof val === 'object' && val !== null) {
            return Object.values(val).some(inner =>
              String(inner).toLowerCase().includes(keyword)
            );
          }
          return String(val).toLowerCase().includes(keyword);
        });

      const normalize = str => str?.toString().trim().toLowerCase();

      const matchBranch =
        !selectedBranch || selectedBranch.value === '' ||
        (normalize(row.branch) === normalize(selectedBranch.label));

      const { start, end } = filters.date || {};
      const fromDate = start ? new Date(start) : null;
      const toDate = end ? new Date(end) : null;

      const matchDate = (() => {
        if (!fromDate && !toDate) return true;

        if (!fromDate || !toDate) return true;

        const rowDate = new Date(row.deliveryDate?.raw);
        rowDate.setHours(0, 0, 0, 0);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(0, 0, 0, 0);

        return rowDate >= fromDate && rowDate <= toDate;
      })();

      const matchStatus =
        (filters.paid && row.status === 'Paid') ||
        (filters.outstanding && row.status === 'Outstanding');

      return matchKeyword && matchBranch && matchDate && matchStatus;
    });
  }, [initialData, filters, selectedBranch, range]);

  // const filteredData = initialData.filter((row) => {
  //   const keyword = filters.keyword.toLowerCase();

  //   const matchKeyword =
  //     filters.keyword === '' ||
  //     Object.entries(row).some(([key, val]) => {
  //       if (typeof val === 'object' && val !== null) {
  //         return Object.values(val).some(inner =>
  //           String(inner).toLowerCase().includes(keyword)
  //         );
  //       }
  //       return String(val).toLowerCase().includes(keyword);
  //     });

  //   const normalize = str => str?.toString().trim().toLowerCase();

  //   const matchBranch =
  //     !selectedBranch || selectedBranch.value === '' ||
  //     (normalize(row.branch) === normalize(selectedBranch.label));

  //   const [start, end] = Array.isArray(range) ? range : [null, null];

  //   const matchDate = !start || !end
  //     ? true
  //     : (() => {
  //       const rowDate = new Date(row.deliveryDate.raw);
  //       rowDate.setHours(0, 0, 0, 0);
  //       return rowDate >= start && rowDate <= end;
  //     })();


  //   const matchStatus =
  //     (filters.paid && row.status === 'Paid') ||
  //     (filters.outstanding && row.status === 'Outstanding');

  //   return matchKeyword && matchBranch && matchDate && matchStatus;
  // });

  useEffect(() => {
    // Avoid re-running if filteredData hasn't changed meaningfully
    if (!filteredData || filteredData.length === 0) {
      setInvoicesByMonth({ thisMonth: 0, lastMonth: 0, twoMonthsAgo: 0 });
      setMonthlyPaidStatusCounts({
        thisMonth: { paid: 0, outstanding: 0 },
        lastMonth: { paid: 0, outstanding: 0 },
        twoMonthsAgo: { paid: 0, outstanding: 0 },
      });
      setMonthlyPaidStatusAmounts({
        thisMonth: { paid: 0, outstanding: 0 },
        lastMonth: { paid: 0, outstanding: 0 },
        twoMonthsAgo: { paid: 0, outstanding: 0 },
      });
      return;
    }

    calculateChartDataFromRows(filteredData);
  }, [filteredData, filters.paid, filters.outstanding, range]);

  const calculateChartDataFromRows = (rows) => {
    const now = new Date();
    const thisMonth = now.getMonth();
    const lastMonth = (thisMonth - 1 + 12) % 12;
    const twoMonthsAgo = (thisMonth - 2 + 12) % 12;
    const thisYear = now.getFullYear();

    const invoicesByMonth = {
      thisMonth: 0,
      lastMonth: 0,
      twoMonthsAgo: 0
    };

    const monthlyPaidStatusCounts = {
      thisMonth: { paid: 0, outstanding: 0 },
      lastMonth: { paid: 0, outstanding: 0 },
      twoMonthsAgo: { paid: 0, outstanding: 0 }
    };

    const monthlyPaidStatusAmounts = {
      thisMonth: { paid: 0, outstanding: 0 },
      lastMonth: { paid: 0, outstanding: 0 },
      twoMonthsAgo: { paid: 0, outstanding: 0 }
    };

    rows.forEach(row => {
      const delivery = new Date(row.deliveryDate.raw);
      const month = delivery.getMonth();
      const year = delivery.getFullYear();
      let amount = parseFloat(row.totalSpent.replace('$', '').replace(/,/g, '')) || 0;

      let monthKey = null;
      if (year === thisYear && month === thisMonth) {
        invoicesByMonth.thisMonth += amount;
        monthKey = 'thisMonth';
      } else if (year === thisYear && month === lastMonth) {
        invoicesByMonth.lastMonth += amount;
        monthKey = 'lastMonth';
      } else if (year === thisYear && month === twoMonthsAgo) {
        invoicesByMonth.twoMonthsAgo += amount;
        monthKey = 'twoMonthsAgo';
      }

      if (monthKey) {
        if (row.status === 'Paid') {
          monthlyPaidStatusCounts[monthKey].paid += 1;
          monthlyPaidStatusAmounts[monthKey].paid += amount;
        } else if (row.status === 'Outstanding') {
          monthlyPaidStatusCounts[monthKey].outstanding += 1;
          monthlyPaidStatusAmounts[monthKey].outstanding += amount;
        }
      }
    });

    // Round values
    Object.keys(invoicesByMonth).forEach(key => {
      invoicesByMonth[key] = parseFloat(invoicesByMonth[key].toFixed(2));
    });
    Object.keys(monthlyPaidStatusAmounts).forEach(key => {
      monthlyPaidStatusAmounts[key].paid = parseFloat(monthlyPaidStatusAmounts[key].paid.toFixed(2));
      monthlyPaidStatusAmounts[key].outstanding = parseFloat(monthlyPaidStatusAmounts[key].outstanding.toFixed(2));
    });

    // Pass data to charts
    setInvoicesByMonth(invoicesByMonth);
    setMonthlyPaidStatusCounts(monthlyPaidStatusCounts);
    setMonthlyPaidStatusAmounts(monthlyPaidStatusAmounts);
  };


  const handleBranchChange = (selected) => {
    setSelectedBranch(selected);
  };

  const handleExportCSV = () => {
    const headers = columns.map(col => col.name);
    const rows = filteredData.map(row => {
      return columns.map(col => {
        const cell = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return `"${(cell && typeof cell === 'object' && 'display' in cell) ? cell.display : cell}"`;
      }).join(',');
    });

    const csvContent = [headers.join(','), ...rows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'billing_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleExportPDF = () => {
    const doc = new jsPDF();

    const headers = [columns.map(col => col.name)];
    const data = filteredData.map(row =>
      columns.map(col => {
        const value = typeof col.selector === 'function' ? col.selector(row) : row[col.selector];
        return (value && typeof value === 'object' && 'display' in value) ? value.display : value;
      })
    );

    doc.autoTable({
      head: headers,
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [52, 73, 94] },
    });

    doc.save('billing_report.pdf');
  };

  return (
    <div className={`reporttables ${filteredData.length === 0 ? 'empty' : ''}`}>
      <div className="filters">
        <div className="divtabe1">
          <label className="labels">Search Keyword</label>
          {/* <input
            type="text"
            id="inputKeyword"
            value={inputKeyword}
            onChange={handleChange}
            placeholder=""
          /> */}
          <input
            type="text"
            id="keyword"
            value={filters.keyword}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <div className="divtabe1">
          <label className="labels">Branch</label>
          {/* <select id="branch" value={filters.branch} onChange={handleChange}>
            <option value="">All Branches</option>
            <option value="Paya Lebar">Paya Lebar</option>
            <option value="Bishan">Bishan</option>
          </select> */}
          <Select
            options={branches}
            value={selectedBranch}
            onChange={handleBranchChange}
            classNamePrefix="custom-select"
          />
        </div>
        {/* <div className="divtabe1">
          <label className="labels">Select By Date Range</label>
         
          <DatePicker
            selected={filters.date ? new Date(filters.date) : null}
            onChange={(date) => {
              //const formattedDate = date ? date.toISOString().split('T')[0] : '';
              const formattedDate = date
                ? date.toLocaleDateString('en-CA')
                : '';
              setFilters(prev => ({
                ...prev,
                date: formattedDate,
              }));
            }}
            placeholderText=" "
            dateFormat="dd/MM/yyyy"
          />
        </div> */}
        {/* <div className="divtabe1">
          <label className="labels">Select By Date Range</label>
          <DateRangePicker id="date" format="dd/MM/yyyy" value={range}
            onChange={(newRange) => {
              setRange(newRange);
            }} placeholder=" " />
        </div> */}
        <div className="divtabe1">
          <label className="labels">From Date</label>
          <DatePicker
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);
              setToDate(null);
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  start: date ? date.toLocaleDateString('en-CA') : null
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
          />
        </div>

        <div className="divtabe1">
          <label className="labels">To Date</label>
          <DatePicker
            selected={toDate}
            onChange={(date) => {
              setToDate(date);
              setFilters(prev => ({
                ...prev,
                date: {
                  ...prev.date,
                  end: date ? date.toLocaleDateString('en-CA') : null
                }
              }));
            }}
            placeholderText=""
            dateFormat="dd/MM/yyyy"
            minDate={fromDate} 
            disabled={!fromDate}
          />
        </div>

        <div className="divtabe1">
          <label className="labels">Payment Status</label>
          <div className="reportcheckbox"><label>
            <input className={filters.paid ? 'checked' : 'unchecked'}
              type="checkbox"
              id="paid"
              checked={filters.paid}
              onChange={handleChange}
            /> Paid
          </label>
            <label>
              <input className={filters.outstanding ? 'checked' : 'unchecked'}
                type="checkbox"
                id="outstanding"
                checked={filters.outstanding}
                onChange={handleChange}
              /> Outstanding
            </label></div>
        </div>
        <div className="divtabe1">
          <label className="labels">Export Table To</label>
          <div className="reportexport">
            <img src={pdf} alt="files" onClick={handleExportPDF} />
            <img src={csv} alt="files" onClick={handleExportCSV} />
          </div>
        </div>
        {/* <div className="divtabe1">
          <label className="labels">1</label>
          <button className="seachbtn"
            onClick={handleSearch}>
            Search
          </button>
        </div>
        <div className="divtabe1">
          <label className="labels">1</label>
          <button className="resetbtn"
            onClick={resetFilters}>
            Reset
          </button>
        </div> */}

      </div>
      {hasLoaded && (
        <>
          <DataTable
            columns={columns}
            data={filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={page => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage) => {
              setRowsPerPage(newPerPage);
              setCurrentPage(1);
            }}
            paginationRowsPerPageOptions={[20, 50, 100]}
            striped
            highlightOnHover
            responsive

          />
          <div className="reportsizelists">
            Showing {filteredData.length === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1}
            &nbsp;to&nbsp;
            {Math.min(currentPage * rowsPerPage, filteredData.length)} of {filteredData.length} entries
          </div>
        </>
      )}
    </div>


  );
}

export default Reportdatatable;